/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Corporate } from '../../models/corporate';

export interface ApiMasterCorporateGetAllGet$Params {
}

export function apiMasterCorporateGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterCorporateGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCorporateGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Corporate>>;
    })
  );
}

apiMasterCorporateGetAllGet.PATH = '/api/Master/Corporate/GetAll';
